import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-segments-modal-wrapper',
  template: `
    <div id="backdrop"></div>
    <div id="container">
      <div id="inner">
        <div align="right">
          <button (click)="onClose()" mat-icon-button id="dialog-close">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <app-segment-multi-share></app-segment-multi-share>
      </div>
    </div>

  `,
  styleUrls: ['./segments-modal-wrapper.component.scss']
})


export class SegmentsModalWrapperComponent implements OnInit {

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

  onClose() {
    this.router.navigateByUrl('/segments');
  }

}
